import "./diagramView.css";
import Header from "./subComponents/header";
import Footer from "./subComponents/footer";
import Patterns from "./subComponents/patterns";
import { roofStructureData } from "../Design&Structure/structureFunction";

const DiagramView = (props) => {
  const { tableContent, structureName, index } = props;

  const pageDetail = tableContent.find(
    (item) => item.title === "Detail Structure Layout"
  );

  const structureDetail = roofStructureData.find(
    (item) => item.name === structureName
  );

  let page = pageDetail?.pageNo || 0;
  let pageNo = page + index;

  return (
    <div id="diagram-view" className="diagram-view">
      {/* Patterns */}
      <Patterns />
      {/* Header */}
      <Header />
      {/* Main Body */}
      <main className="dv-body">
        <p>{`Detail Structure Layout(${structureName})`}</p>
        <>
          <img className="img" src={structureDetail.layout1} alt="map" />
          <img className="img1" src={structureDetail.layout2} alt="map" />
        </>
      </main>

      {/* Footer */}
      <Footer
        pageNo={`${pageDetail ? pageNo : 12}/${
          tableContent[tableContent.length - 1].pageNo
        }`}
      />
    </div>
  );
};

export default DiagramView;
